module.exports = __webpack_public_path__ + "img/DSC03570-2.01f090a1.jpg";